import { createSlice } from '@reduxjs/toolkit';
import { constructorReducer } from './constructor.reducer';
var initialState = {
    fetch_data: {
        group: '',
        fetch_name: '',
    },
    loading: false,
    status: 0,
    error: null,
    data: null,
    createConstructionData: null,
    reportInfo: null,
    file: null,
    constructionsSheet: [],
    reportInfoFull: null,
};
export var constructorSlice = createSlice({
    name: 'responseData',
    initialState: initialState,
    reducers: {
        setInfo: constructorReducer.setInfo,
        setFile: constructorReducer.setFile,
        setAboutBuilding: constructorReducer.setAboutBuilding,
        setCreateConstructionData: constructorReducer.setCreateConstructionData,
        setConstructionsSheet: constructorReducer.setConstructionSheets,
        setInfoFull: constructorReducer.setInfoFull,
    },
});
